import * as React from 'react';
import { Box } from '@locus-taxy/encore-mui';
import { createInstance } from '@module-federation/enhanced/runtime';
import ReactDOM from 'react-dom';
import * as ReactRouterDOM from 'react-router-dom';
import LoadingSpinner from '../LoadingSpinner';
import { CUSTOM_APP_BASE_URL } from '../../config';
import { getTestId } from '@locus-taxy/encore-utils';
import { useRouteContext } from '../../hooks/useRouteContext';
import { TestIdAction } from '../../utils/testIdUtils';

// Define the interface for the TourDetails component props
interface TourDetailsProps {
  entityData: any;
}

const mf = createInstance({
  name: 'host',
  remotes: [
    {
      name: 'tour-details',
      entry: `${CUSTOM_APP_BASE_URL}/tour-details/mf-manifest.json`,
    },
  ],
  shared: {
    react: {
      version: '19.1.0',
      scope: 'default',
      lib: () => React,
      shareConfig: {
        singleton: true,
        requiredVersion: '^19.1.0',
      },
    },
    'react-dom': {
      version: '19.1.0',
      scope: 'default',
      lib: () => ReactDOM,
      shareConfig: {
        singleton: true,
        requiredVersion: '^19.1.0',
      },
    },
    'react-router-dom': {
      version: '7.6.3',
      scope: 'default',
      lib: () => ReactRouterDOM,
      shareConfig: {
        singleton: true,
        requiredVersion: '^7.6.3',
      },
    },
  },
});

const TourDetailsLazy = React.lazy(() =>
  mf
    .loadRemote('tour-details/App')
    .then((mod: any) => ({ default: mod.default }))
) as React.LazyExoticComponent<React.ComponentType<TourDetailsProps>>;

export const TourDetailsContainer = ({
  entityData,
}: {
  entityData: any;
  remountKey?: number;
}) => {
  const { entity, page } = useRouteContext();

  return (
    <Box
      sx={{
        overflow: 'auto',
        borderRight: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }}
      data-testid={getTestId({
        action: TestIdAction.VIEW,
        object: 'tour-details-container',
        entity: entity ?? 'tour',
        page: page ?? 'details',
      })}
    >
      <React.Suspense fallback={<LoadingSpinner />}>
        <TourDetailsLazy entityData={entityData} />
      </React.Suspense>
    </Box>
  );
};
